'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliverySelector = function DeliverySelector(el) {
  (0, _classCallCheck3.default)(this, DeliverySelector);

  (0, _jquery2.default)('#country').change(function () {
    (0, _jquery2.default)('.sec-Delivery_Item').hide();
    if (_jsCookie2.default) {
      _jsCookie2.default.set('deliver-to', (0, _jquery2.default)(this).val());
    }
    (0, _jquery2.default)('#info-' + (0, _jquery2.default)(this).val()).show().siblings().hide();
  });

  // On page load, read out the cookie, and select the corresponding country
  // If no cookie, set UK as default
  var country = _jsCookie2.default && _jsCookie2.default.get('deliver-to') || 'country-united-kingdom';
  (0, _jquery2.default)('#country').val(country).trigger('change');
};

exports.default = DeliverySelector;